// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__G8_PA"};